import React, { Component } from 'react'

import { Get } from 'utils/axios'

const HOC = WrappedComponent => {
  class WithHOC extends Component {
    state = {
      loading: false,
      patients: [],
      searchPatientParam: ''
    }

    load = param => this.setState({ loading: param })

    onChangePatientsHOC = ( key, val ) => this.setState({ [ key ] : val })

    getPatients = ( searchPatientParam ) => Get(
      `/patients?page=1&search=${ searchPatientParam }`,
      this.getPatientsSuccess,
      this.getPatientsError,
      this.load
    )
    getPatientsSuccess = payload => this.setState({ patients: payload.data })
    getPatientsError = error => {}

    render = () => {
      return (
        <WrappedComponent 
          { ...this.props }
          getPatients={ this.getPatients }
          onChangePatientsHOC={ this.onChangePatientsHOC }
          onLoadPatientsHOC={ this.state.loading }
          patients={ this.state.patients }
          searchPatientParam={ this.state.searchPatientParam } />
      )
    }
  }
  return WithHOC
}

export default HOC